export default __webpack_public_path__ + "static/d695b82391c8b01f5615e3f89fb19fbc.png";